// Memoiza a busca de motivos (taxonomia fixa, muda raramente) para que os
// varios pontos de uso do RegistrarTentativa/Kanban nao disparem uma consulta
// redundante por instancia montada.
import { fetchMotivos } from "./leads";
import type { Motivo, MotivoCategoria } from "./types";

const cache = new Map<MotivoCategoria, Promise<Motivo[]>>();

export function fetchMotivosCached(categoria: MotivoCategoria): Promise<Motivo[]> {
  const existing = cache.get(categoria);
  if (existing) return existing;
  const promise = fetchMotivos(categoria);
  cache.set(categoria, promise);
  promise.catch(() => cache.delete(categoria));
  return promise;
}
